import api from '..'

export interface LibraryImage {
  url: string
  name: string
}

export async function getImages(): Promise<LibraryImage[]> {
  const res = await api.get('/images')
  return res.data.data
}
